<div class="app-home-routing">
  <router-outlet></router-outlet>
</div>
<app-shared-footer></app-shared-footer>
